import React from 'react';
import { withStyles } from '@material-ui/styles';
import { withNamespaces } from 'react-i18next';
const footer = require('../../../../../public/hb_powered_by_int.png');
import { fetchGoThumbSignedUrl } from 'utilsModule/gothumb';
import IndividualReportingVitalsChart from './ReportingVitalsChart';
import IndividualReportingCaretaskChart from './ReportingCaretaskChart';
import IndividualReportingAlertsChart from './ReportingAlertsChart';
import ReportFooter from '../../component/ReportPDF/ReportFooter';
import ReportPage from 'appModule/reporting/component/ReportPDF/ReportPage';
import * as moment from 'moment';

const styles = () => ({
  container: {
    backgroundColor: 'white',
    width: '21cm',
    height: '29.7cm',
    overflow: 'hidden',
  },
  metadataTitle: {
    width: '40%',
    fontSize: 12,
  },
  metadataValue: {
    width: '60%',
    fontSize: 12,
  },
  metadataSpace: {
    height: 5,
  },
});
@withNamespaces('reports', { wait: true })
@withStyles(styles, { index: 1 })
export default class ReportingMetaData extends React.Component {
  state = {
    loading: true,
    metaData: null,
    module: null,
  };

  constructor(props) {
    super(props);

    if(this.props.location.query['session-language']) {
      this.props.i18n.changeLanguage(this.props.location.query['session-language']);
    }
  }

  async componentDidMount() {
    await this.fetchReportMetaData();
  }

  async fetchReportMetaData() {
    const { 'session-token': sessionToken, reportId, module } = this.props.location.query;
    this.setState({
      module,
    });

    const { API_URL } = window.MILO_CONFIG;
    fetch(`${API_URL}/reports/${reportId}/metaData?session-token=${sessionToken}`, { method: 'GET' })
      .then((res) => res.json())
      .then((json) => json.value)
      .then(async (metaData) => {
        const goThumbUrl = await fetchGoThumbSignedUrl(metaData.hospitalLogo, sessionToken);
        this.setState({
          loading: false,
          metaData: {
            ...metaData,
            hospitalLogo: goThumbUrl,
          },
        });
      });
  }

  _header = () => {
    const { metaData } = this.state;
    const { classes, t } = this.props;
    if (!metaData) return;
    const lastSyncDate = metaData && metaData.lastSync ? moment(metaData.lastSync).format('DD MMM YYYY, HH:mm') : null;
    return (
      <div style={{ width: '100%' }}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img src={metaData.hospitalLogo} style={{ width: 110, height: 110, marginTop: 12, marginBottom: 12 }} />{' '}
        </div>{' '}
        <div
          style={{
            width: '100%',
            textAlign: 'center',
            fontSize: 20,
            fontWeight: 'bold',
            fontFamily: 'Roboto',
            marginTop: 12,
            marginBottom: 12,
          }}>
          {metaData.reportName}{' '}
        </div>{' '}
        <table style={{ width: '100%' }}>
          <tr>
            <td className={classes.metadataTitle}> {t('participantName')} </td>{' '}
            <td className={classes.metadataValue}>
              : {metaData.patient.firstName} {metaData.patient.lastName}{' '}
            </td>{' '}
          </tr>{' '}
          <tr>
            <td className={classes.metadataTitle}> {t('participantIdType')} </td>{' '}
            <td className={classes.metadataValue}>
              : {metaData.patientIdentification.type} and {metaData.patientIdentification.value}{' '}
            </td>{' '}
          </tr>{' '}
          <tr>
            <td className={classes.metadataSpace} /> <td className={classes.metadataSpace} />{' '}
          </tr>{' '}
          <tr>
            <td className={classes.metadataTitle}> {t('providerName')} </td>{' '}
            <td className={classes.metadataValue}>
              : {metaData.provider.firstName} {metaData.provider.lastName}{' '}
            </td>{' '}
          </tr>{' '}
          <tr>
            <td className={classes.metadataTitle}> {t('hospitalClinicName')} </td>{' '}
            <td className={classes.metadataValue}>: {metaData.hospitalName} </td>{' '}
          </tr>{' '}
          {/* <tr>
                                <td className={classes.metadataTitle}>Report Name</td>
                                <td className={classes.metadataValue}>: {metaData.reportName}</td>
                              </tr> */}{' '}
          <tr>
            <td className={classes.metadataTitle}> {t('selectProgramme')} </td>{' '}
            <td className={classes.metadataValue}>: {metaData.enrolledPrograms.join(', ')} </td>{' '}
          </tr>{' '}
          <tr>
            <td className={classes.metadataTitle}> {t('periodOfReport')} </td>{' '}
            <td className={classes.metadataValue}>: {metaData.period} </td>{' '}
          </tr>{' '}
          <tr>
            <td className={classes.metadataSpace} /> <td className={classes.metadataSpace} />{' '}
          </tr>{' '}
          <tr>
            <td className={classes.metadataTitle}> {t('dateTimeReportDownloaded')}</td>{' '}
            <td className={classes.metadataValue}>: {metaData.dateAndTime} </td>{' '}
          </tr>{' '}
          {lastSyncDate && (
            <tr>
              <td className={classes.metadataTitle}> {t('dateTimeDataLastSynced')}</td>{' '}
              <td className={classes.metadataValue}>: {lastSyncDate} </td>{' '}
            </tr>
          )}{' '}
          <tr>
            <td className={classes.metadataTitle}> {t('downloadedBy')} </td>{' '}
            <td className={classes.metadataValue}>: {metaData.downloadedBy} </td>{' '}
          </tr>{' '}
        </table>{' '}
      </div>
    );
  };

  render() {
    const { loading, metaData, module } = this.state;
    const { page = 1, totalPages = 10 } = this.props.location.query;
    if (loading || !metaData) return <div> Loading... </div>;

    return (
      <ReportPage page={page} totalPages={totalPages}>
        {this._header()}
        {module === 'vitals' && <IndividualReportingVitalsChart {...this.props} isEmbedded={true} />}
        {/* {module === 'care_tasks' && <IndividualReportingCaretaskChart {...this.props} isEmbedded={true} />}
        {module === 'alerts' && <IndividualReportingAlertsChart {...this.props} isEmbedded={true} />}{' '} */}
      </ReportPage>
    );
  }
}
